'use client'

import { Button, Divider, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  feedbacks_path: string
}

const HelpCenterFaqFeedbackFormLink = ({ feedbacks_path }: Props) => {
  const translate = useTranslate('help_center_feedback.feedback_form_link')

  return (
    <>
      <Divider />
      <Spacer size="x-large" />
      <Button
        url={feedbacks_path}
        text={translate('fill_feedback_form_text')}
        styling="filled"
        size="medium"
        testId="fill-feedback-form-button"
        inline
      />
    </>
  )
}

export default HelpCenterFaqFeedbackFormLink
